module.exports = __webpack_public_path__ + "img/left-side-menu-download.901017e7.svg";